import React, { useEffect, useState } from 'react';
import { useSession } from 'hooks/use-session.hook';
import { useTranslation } from 'react-i18next';
import { openModal } from 'services/modal';
import ModalUserProfile from 'pages/user/user-profile';
import { getMasterData } from 'services/master-data';
import { StatusSlidebar } from 'consts/common.const';

export default function Header({
  setIsCheckCollapse,
  clientWidth,
}: {
  setIsCheckCollapse: (...arg) => void;
  clientWidth: number;
}) {
  const { logout, userInfo } = useSession();
  const { t } = useTranslation();
  const [sidebarStatus, setSidebarStatus] = useState<string>();

  const onLogout = () => {
    logout();
  };

  const openModalEditUser = () => {
    const modal = openModal(ModalUserProfile, { data: { row: userInfo } });

    modal.afterClosed().subscribe();
  };

  useEffect(() => {
    requestAnimationFrame(() => {
      getMasterData('getGeneral').subscribe((res) => {
        const body = document.querySelector('body');
        const status = Number(res.data.find((item) => item.key === 'status_slidebar').value);

        if (status === StatusSlidebar.expand || (clientWidth >= 992 && status === StatusSlidebar.default)) {
          if (document.body.getAttribute('class').includes('sidebar-collapse')) {
            body.classList.remove('sidebar-collapse');
          }
        } else {
          if (!body.getAttribute('class').includes('sidebar-collapse') && clientWidth >= 768) {
            body.classList.add('sidebar-collapse');
          }
        }

        setSidebarStatus(status === StatusSlidebar.default || clientWidth < 992 ? 'pushmenu' : '');
      });
    });
  }, [clientWidth]);

  const handleClick = () => {
    if (clientWidth >= 768) {
      return setIsCheckCollapse(!document.body.getAttribute('class').includes('sidebar-collapse'));
    }
  };

  return (
    <nav className='main-header navbar navbar-expand navbar-white navbar-light'>
      {/* Left navbar links */}
      <ul className='navbar-nav'>
        <li className='nav-item'>
          {sidebarStatus && (
            <a className='nav-link' data-widget={sidebarStatus} href='#' onClick={handleClick} role='button'>
              <i className='fas fa-bars' />
            </a>
          )}
        </li>
      </ul>
      {/* Right navbar links */}

      <ul className='navbar-nav ml-auto'>
        {/* Notifications Dropdown Menu */}
        <li className='nav-item dropdown'>
          <a className='nav-link mr-2 d-flex align-content-center' data-toggle='dropdown' href='#'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='23'
              height='23'
              fill='currentColor'
              className='bi bi-person-circle'
              viewBox='0 0 16 16'
            >
              <path d='M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z' />
              <path
                fillRule='evenodd'
                // eslint-disable-next-line max-len
                d='M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z'
              />
            </svg>
            <span className='ml-2 user-profile-label'>{userInfo && userInfo.username}</span>
          </a>

          <div className='dropdown-menu dropdown-menu-md dropdown-menu-right'>
            <a className='dropdown-item nav-link' role={'button'} onClick={openModalEditUser}>
              <i className='fas fa-user mr-2' /> {t('header.menu.user_profile')}
            </a>

            <div className='dropdown-divider' />
            <a className='nav-link' role='button' onClick={onLogout}>
              <i className='fas fa-sign-out-alt mr-2' />
              {t('header.menu.item.logout')}
            </a>
          </div>
        </li>
      </ul>
    </nav>
  );
}
